import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";
import {InputSwitch} from "primereact/inputswitch";
import { AutoComplete } from 'primereact/autocomplete';

const IdentifierFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});
  const [projects, setProjects] = useState(null);
  const [projectDisplay, setProjectDisplay] = useState("");
  const [projectSuggestions, setProjectSuggestions] = useState([]);
  const [projectSelected, setProjectSelected] = useState(false);
  const [qrCodeLoading, setQrCodeLoading] = useState(false);
  const [qrCodeError, setQrCodeError] = useState(null);
  const [qrCodeUrl, setQrCodeUrl] = useState(null);
  const [types, setTypes] = useState([]);

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    const currentName = (newFormData.name ?? formData.name ?? data.name ?? "").toString().trim();
    const finalName = currentName !== "" ? currentName : projectDisplay;
    if ((window.App.urlVars().identifierId) || (entity === 'identifier' && id)) {
      const payload = {
        ...formData,
        ...newFormData,
        name: finalName,
        identifier: formData.identifier,
        project: newFormData.project ?? formData.project ?? null,
        active: !!(newFormData.active ?? formData.active), 
      }
      apiCall('patch', '/api/v2/identifier/' + formData.id, payload)
        .then(response => {
          window.App.toastShow('success', t('toastSaveSuccess'));
          window.App.setState({rerenderIdentifierList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      const payload = {
        ...data,
        name: finalName
      }
      apiCall('post', '/api/v2/identifier', payload)
        .then(response => {
          window.App.toastShow('success', t('toastSaveSuccess'));
          window.App.setState({rerenderIdentifierList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/settings/identifier/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCallBlob = (method, url) => {
    return axios({
      method,
      url: process.env.REACT_APP_API_HOST + url,
      responseType: 'blob',
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    });
  };

  const fetchQrCode = async (identifierId) => {
    if (!identifierId) return;
    if (qrCodeUrl) {
      URL.revokeObjectURL(qrCodeUrl);
      setQrCodeUrl(null);
    }
    setQrCodeLoading(true);
    setQrCodeError(null);
    try {
      const res = await apiCallBlob('get', `/api/v2/identifier/${identifierId}/qrcode`);
      const objectUrl = URL.createObjectURL(res.data);
      setQrCodeUrl(objectUrl);
    } catch (error) {
      setQrCodeError(t('qrCodeLoadError'));
    } finally {
      setQrCodeLoading(false);
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const searchProject = (event) => {
    const query = (event.query || "").toLowerCase().trim();
    if (!query) {
      setProjectSuggestions([]);
      return;
    }
    const filtered = projects
      .filter(p => {
        const name = (p.name || "").toLowerCase();
        return name.includes(query);
      })
      .map(p => ({
        ...p,
        name: p.name
      }));

    setProjectSuggestions(filtered);
  };

  useEffect(() => {
    if (((!window.App.urlVars().create && window.App.urlVars().identifierId) || (entity === 'identifier' && id)) 
        && window.App.urlVars().identifierId !== "undefined" 
        && id !== "undefined") {
      setLoading(true);
      apiCall('get', '/api/v2/identifier/' + (window.App.urlVars().identifierId ?? id))
        .then(response => {
          setFormData({
            ...response.data.data,
            project: response.data.data.project?.id || null,
            location: response.data.data.location?.id || null,
          });
          setProjectDisplay(response.data.data.project?.name ?? "");
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [id])

  useEffect(() => {
    setLoading(true);
    apiCall('get', '/api/v2/project')
      .then(response => {
        setProjects(response.data.data)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setLoading(false);
      })
    apiCall('get', '/api/v2/dictionary/identifier-type')
      .then(response => {
        setTypes(response.data.data)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setLoading(false);
      })  
  }, [])

  useEffect(() => {
    const vars = window.App.urlVars();
    const identifierId = formData?.id ?? vars.identifierId ?? id;
    const isEditing =
      !!identifierId &&
      ((!vars.create && vars.identifierId) || (entity === 'identifier' && id));
    const currentType = (newFormData?.type ?? formData?.type);
    if (!isEditing || currentType !== 'QRCODE') {
      if (qrCodeUrl) URL.revokeObjectURL(qrCodeUrl);
      setQrCodeUrl(null);
      setQrCodeError(null);
      setQrCodeLoading(false);
      return;
    }
    fetchQrCode(identifierId);
    return () => {
      if (qrCodeUrl) URL.revokeObjectURL(qrCodeUrl);
    };
  }, [formData?.id, formData?.type, newFormData?.type]);

  useEffect(() => {
    const vars = window.App.urlVars();
    if (vars.projectName) {
      setProjectDisplay(decodeURIComponent(vars.projectName));
      setFormData(prev => ({ ...prev, project: vars.projectId || prev.project }));
      setNewFormData(prev => ({ ...prev, project: vars.projectId || prev.project }));
    }
  }, [window.App.urlVars().projectName]);

  return (
    <div className={"identifier-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>

            <div className={"p-col-12 p-lg-6"}>
              <Field name="identifier" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="identifier"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldIdentifier')}</label>
                  <span className="p-d-block">
                      <InputText id="identifier" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     identifier: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     identifier: e.target.value
                                   })
                                 }}
                                 value={formData.identifier}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                    <small className="p-text-secondary p-d-block p-mt-1">
                      {t('identifierAutoGenerateHint')}
                    </small>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="type" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="type"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldType')}</label>
                  <span className="p-d-block">
                      <Dropdown id="type" {...input}
                                 options={window.App.sortDropdownOptions(types, "value")}
                                 optionLabel='value'
                                 optionValue='key'
                                 placeholder={t('selectTypeTruncatedPlaceholder')}onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     type: e.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     type: e.value
                                   })
                                 }}
                                 value={formData.type}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>

            <div className={"p-col-12 p-lg-6"}>
                <Field name="project" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="project" className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('project')}</label>
                    <span className="p-inputgroup">
                    <Button
                      type="button"
                      className="p-button"
                      onClick={() => {
                        let paramsObj = {...window.App.urlVars()};
                        paramsObj.search = 'project';
                        let _params = "?";
                        Object.entries(paramsObj).forEach(([key, value]) => {
                          _params += key + "=" + value + "&";
                        });
                        history.push(window.location.hash.replace("#", "") + _params);
                      }}
                    >
                      <i className="pi pi-search"></i>
                    </Button>

                    <AutoComplete
                      id="project"
                      value={projectDisplay}
                      suggestions={projectSuggestions}
                      completeMethod={searchProject}
                      field={"name"}
                      delay={800}
                      forceSelection
                      placeholder={t('projectTypeToSearchPlaceholder')}
                      className={classNames({'p-invalid': isFormFieldValid(meta)})}

                      onSelect={(e) => {
                        const picked = e.value;
                        setProjectSelected(true);
                        setProjectDisplay(picked.name || "");
                        const pickedProjectId = picked.id || null;
                        const pickedLocationId = picked.location?.id || null;
                        setFormData(prev => ({
                          ...prev,
                          project: pickedProjectId,
                          location: pickedLocationId || null
                        }));
                        setNewFormData(prev => ({
                          ...prev,
                          project: pickedProjectId,
                          location: pickedLocationId || null
                        }));
                      }}

                      onChange={(e) => {
                        if (projectSelected) {
                          setProjectSelected(false);
                          return;
                        }
                        setProjectDisplay(e.value);

                        setFormData({
                          ...formData,
                          project: e.target.value
                        });
                        setNewFormData({
                          ...newFormData,
                          project: e.target.value
                        });
                      }}

                      onClear={() => {

                        setProjectDisplay("");
                        setFormData({
                          ...formData,
                          project: null
                        });
                        setNewFormData({
                          ...newFormData,
                          project: null
                        });
                      }}
                    />
                  </span>

                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>

            <div className={"p-col-12 p-lg-6"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className="p-col-12 p-lg-4">
              <Field name="active" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldActive')}</label>
                  <div className="field-control">
                    <InputSwitch
                      checked={!!formData.active}
                      onChange={(e) => {
                        const v = !!e.value;
                        setFormData(prev => ({ ...prev, active: v }));
                        setNewFormData(prev => ({ ...prev, active: v }));
                      }}
                    />  
                    {getFormErrorMessage(meta)}
                  </div>
                </div>
              )}/>
            </div>

          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'identifier' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
          {formData?.type === 'QRCODE' && (() => {
            return (
              <div className="p-grid p-mt-3">
                <div className="p-col-12">
                  <div className="p-p-3" style={{border: '1px solid #e5e7eb', borderRadius: 8, background: '#fff'}}>
                    <div className="p-d-flex p-jc-between p-ai-center p-mb-2">
                      <strong>{t('qrCode')}</strong>
                    </div>
                    {qrCodeLoading && (
                      <div className="p-d-flex p-ai-center">
                        <i className="pi pi-spin pi-spinner p-mr-2" />
                        <span>{t('qrCodeLoading')}</span>
                      </div>
                    )}
                    {qrCodeError && <small className="p-error">{qrCodeError}</small>}
                    {!qrCodeLoading && qrCodeUrl && (
                      <div className="p-mt-2">
                        <img src={qrCodeUrl} alt={t('qrCode')} style={{maxWidth: 260, width: '100%', height: 'auto', display: 'block'}} />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })()}
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(IdentifierFormComponent);
